import styles from './InfoChip.module.scss';

export type InfoChipType = 'primary' | 'text' | 'info' | 'warning' | 'success' | 'danger';

export interface InfoChipProps {
  /** The label text to display */
  label: string;
  /** The visual type/variant of the chip */
  type?: InfoChipType;
  /** Optional icon to display before the label */
  icon?: React.ReactNode;
  /** Whether to show the icon (default: true) */
  showIcon?: boolean;
  /** Additional CSS classes */
  className?: string;
}

export const InfoChip = ({
  label,
  type = 'primary',
  icon,
  showIcon = true,
  className = '',
}: InfoChipProps) => {
  const containerClassName = [
    styles.chip,
    styles[type],
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClassName}>
      {showIcon && icon && (
        <span className={styles.icon}>{icon}</span>
      )}
      <span className={styles.label}>{label}</span>
    </div>
  );
};
